import React, { useEffect, useRef } from "react";
import styles from './RoundelPicture.module.css';

export default function RoundelPicture({imgPath}){

    const circle1 = useRef();
    const circle2 = useRef();
    const circle3 = useRef();
    const circle4 = useRef();

    const outerRef = useRef();

    const colorArray = ['--ink-black','--dusty-grape','--deep-sky-blue','--gunmetal'];

    useEffect(() => {
        randomifyAll();
    },[circle1,circle2,circle3]);

    const randomify = (ref,quarter,minusPlus) => {
        if(ref.current && outerRef.current){
            const color = colorArray[Math.floor(Math.random()*colorArray.length)]
            var r = document.querySelector(':root');
            var rs = getComputedStyle(r);

            const outerWidth = outerRef.current.getBoundingClientRect().width;
            
            const randomSize = (Math.random()*5*16)+32;
            ref.current.style.width = randomSize+'px';
            ref.current.style.backgroundColor = rs.getPropertyValue(color);
            const correction = (outerWidth - randomSize)/2;
            

            const x = ((Math.random()*0.25)+(quarter))*outerWidth;
            const y = Math.sin(Math.acos(x/(outerWidth/2)))*(outerWidth/2);

            // const minusPlus = Math.round(Math.random());

            ref.current.style.top = `${minusPlus? correction+y : correction-y}px`;
            ref.current.style.left = correction+x+'px';
        }
    }

    const randomifyAll = () => {
        randomify(circle1,-0.5,false);
        randomify(circle2,-0.25,true);
        randomify(circle3,0,false);
        randomify(circle4,0.25,true);
    }
    
    return (
        <div ref={outerRef} className={styles.outerCon}>
            <div className={styles.introPictureRoundel} onMouseEnter={randomifyAll}>
                <img src={imgPath}/>
            </div>
            <div ref={circle1} onClick={() => randomify(circle1)} className={styles.circle} style={{top: '1rem'}}></div>
            <div ref={circle2} onClick={() => randomify(circle2)} className={styles.circle} style={{top: '2rem'}}></div>
            <div ref={circle3} onClick={() => randomify(circle3)} className={styles.circle} style={{top: '3rem'}}></div>
            <div ref={circle4} onClick={() => randomify(circle4)} className={styles.circle} style={{top: '3rem'}}></div>
        </div>
    )
}